// Copyright 2017 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { RecordingGroupContainer } from "datatypes/Containers";
import { IStorageService } from "services/Storage/IStorageService";

@autoinject
export class StorageServiceExtensions {
    public static removeRecordingFromGroup(
        storageService: IStorageService,
        recordingId: string,
        recordingGroupId: string
    ): Promise<void> {
        // Delete the recording from the group
        return storageService.load(recordingGroupId).then((recordingGroup: RecordingGroupContainer) => {
            const recordingsPromise: Promise<void> = Promise.resolve();
            const stepsPromise: Promise<void> = Promise.resolve();

            // If the recording is present in a group, remove it from that group
            const recordingsIdx = recordingGroup.metadata.recordings.indexOf(recordingId);
            if (recordingsIdx != -1) {
                recordingGroup.metadata.recordings.splice(recordingsIdx, 1);
            }

            // If the recording is present in a step of that group, remove it from that step
            const stepIdx = recordingGroup.metadata.steps
                ? recordingGroup.metadata.steps.findIndex((x) => x.recordingId == recordingId)
                : -1;
            if (stepIdx != -1) {
                recordingGroup.metadata.steps[stepIdx].recordingId = undefined;
            }

            return storageService.updateMetadataSet(recordingGroup.id, {
                recordings: recordingGroup.metadata.recordings,
                steps: recordingGroup.metadata.steps,
            });
        });
    }
}
